<template>
  <div class="card p-shadow-app p-p-4">
    <div class="p-d-flex p-jc-between p-ai-center p-mb-3">
      <h2 class="p-m-0">Fornecedores</h2>
    </div>

    <div style="height: 65vh">
      <DataTable
        :value="suppliers"
        :filters.sync="filters"
        :loading="loading"
        responsiveLayout="scroll"
        filterDisplay="row"
        class="p-datatable-sm"
        scrollable
        scrollHeight="flex"
        :paginator="true"
        :rows="perPage"
        :rowsPerPageOptions="[10, 20, 50, 100]"
        :lazy="true"
        :totalRecords="totalRecords"
        @filter="fetchSuppliers"
        @page="fetchSuppliers"
      >
        <template #header>
          <div>
            <Button
              icon="pi pi-plus"
              @click="createSupplier()"
              v-if="can('seeSuppliers')"
            />
          </div>
        </template>
        <template #empty> Nenhum fornecedor encontrado. </template>
        <template #loading> A carregar... </template>

        <Column
          field="id"
          header="ID"
          filterField="id"
          :headerStyle="{ 'min-width': '8%', 'max-width': '8%' }"
          :filterHeaderStyle="{ 'min-width': '8%', 'max-width': '8%' }"
          :bodyStyle="{ 'min-width': '8%', 'max-width': '8%' }"
        >
          <template #filter="{ filterModel, filterCallback }">
            <InputText
              v-model="filterModel.value"
              class="p-column-filter"
              @input="filterCallback()"
            />
          </template>
        </Column>

        <Column
          field="name"
          header="Nome"
          filterField="name"
          :headerStyle="{ 'min-width': '15%', 'max-width': '15%' }"
          :filterHeaderStyle="{ 'min-width': '15%', 'max-width': '15%' }"
          :bodyStyle="{ 'min-width': '15%', 'max-width': '15%' }"
        >
          <template #filter="{ filterModel, filterCallback }">
            <InputText
              v-model="filterModel.value"
              class="p-column-filter"
              @input="filterCallback()"
            />
          </template>
        </Column>

        <Column
          field="email"
          header="Email"
          filterField="email"
          :headerStyle="{ 'min-width': '15%', 'max-width': '15%' }"
          :filterHeaderStyle="{ 'min-width': '15%', 'max-width': '15%' }"
          :bodyStyle="{ 'min-width': '15%', 'max-width': '15%' }"
        >
          <template #filter="{ filterModel, filterCallback }">
            <InputText
              v-model="filterModel.value"
              class="p-column-filter"
              @input="filterCallback()"
            />
          </template>
        </Column>

        <Column
          field="telephone"
          header="Telefone"
          filterField="telephone"
          :headerStyle="{ 'min-width': '10%', 'max-width': '10%' }"
          :filterHeaderStyle="{ 'min-width': '10%', 'max-width': '10%' }"
          :bodyStyle="{ 'min-width': '10%', 'max-width': '10%' }"
        >
          <template #filter="{ filterModel, filterCallback }">
            <InputText
              v-model="filterModel.value"
              class="p-column-filter"
              @input="filterCallback()"
            />
          </template>
        </Column>

        <Column
          field="mobilPhone"
          header="Telemóvel"
          filterField="mobilPhone"
          :headerStyle="{ 'min-width': '10%', 'max-width': '10%' }"
          :filterHeaderStyle="{ 'min-width': '10%', 'max-width': '10%' }"
          :bodyStyle="{ 'min-width': '10%', 'max-width': '10%' }"
        >
          <template #filter="{ filterModel, filterCallback }">
            <InputText
              v-model="filterModel.value"
              class="p-column-filter"
              @input="filterCallback()"
            />
          </template>
        </Column>

        <Column
          field="address"
          header="Morada"
          filterField="address"
          :headerStyle="{ 'min-width': '15%', 'max-width': '15%' }"
          :filterHeaderStyle="{ 'min-width': '15%', 'max-width': '15%' }"
          :bodyStyle="{ 'min-width': '15%', 'max-width': '15%' }"
        >
          <template #filter="{ filterModel, filterCallback }">
            <InputText
              v-model="filterModel.value"
              class="p-column-filter"
              @input="filterCallback()"
            />
          </template>
        </Column>

        <Column
          field="city"
          header="Localidade"
          filterField="city"
          :headerStyle="{ 'min-width': '10%', 'max-width': '10%' }"
          :filterHeaderStyle="{ 'min-width': '10%', 'max-width': '10%' }"
          :bodyStyle="{ 'min-width': '10%', 'max-width': '10%' }"
        >
          <template #filter="{ filterModel, filterCallback }">
            <InputText
              v-model="filterModel.value"
              class="p-column-filter"
              @input="filterCallback()"
            />
          </template>
        </Column>

        <Column
          field="fiscalNumber"
          header="NIF"
          filterField="fiscalNumber"
          :headerStyle="{ 'min-width': '10%', 'max-width': '10%' }"
          :filterHeaderStyle="{ 'min-width': '10%', 'max-width': '10%' }"
          :bodyStyle="{ 'min-width': '10%', 'max-width': '10%' }"
        >
          <template #filter="{ filterModel, filterCallback }">
            <InputText
              v-model="filterModel.value"
              class="p-column-filter"
              @input="filterCallback()"
            />
          </template>
        </Column>

        <Column
          header="Ações"
          v-if="can('seeSuppliers')"
          :headerStyle="{ 'min-width': '5%', 'max-width': '5%' }"
          :filterHeaderStyle="{ 'min-width': '5%', 'max-width': '5%' }"
          :bodyStyle="{ 'min-width': '5%', 'max-width': '5%' }"
        >
          <template #body="slotProps">
            <Button
              icon="pi pi-pencil"
              class="p-button-sm p-button-text"
              @click="updateSupplier(slotProps.data)"
            />
          </template>
        </Column>
      </DataTable>
    </div>
    <SupplierModal
      :visible.sync="modalVisible"
      :data="formData"
      @cancel="closeForm"
      @created="createdSupplier"
      @updated="updatedSupplier"
    />
  </div>
</template>

<script>
import SupplierService from "@/services/supplier.service";
import { FilterMatchMode } from "primevue/api";
import SupplierModal from "@/components/suppliers/SupplierModal.vue";

export default {
  name: "SupplierList",
  components: { SupplierModal },
  data() {
    return {
      loading: false,
      suppliers: [],
      totalRecords: 0,
      currentPage: 1,
      perPage: 50,
      modalVisible: false,
      formData: {
        id: null,
        name: "",
        name2: "",
        fiscalNumber: "",
        telephone: "",
        mobilPhone: "",
        email: "",
        address: "",
        city: "",
        zipCode: "",
        nib: "",
        type: "",
        url: "",
        obs: "",
      },
      filters: {
        id: { value: null, matchMode: FilterMatchMode.CONTAINS },
        name: { value: null, matchMode: FilterMatchMode.CONTAINS },
        email: { value: null, matchMode: FilterMatchMode.CONTAINS },
        telephone: { value: null, matchMode: FilterMatchMode.CONTAINS },
        mobilPhone: { value: null, matchMode: FilterMatchMode.CONTAINS },
        fiscalNumber: { value: null, matchMode: FilterMatchMode.CONTAINS },
        address: { value: null, matchMode: FilterMatchMode.CONTAINS },
        city: { value: null, matchMode: FilterMatchMode.CONTAINS },
      },
    };
  },
  async activated() {
    await this.fetchSuppliers();
  },
  async created() {
    await this.fetchSuppliers();
  },
  methods: {
    buildQueryParams(page = 1) {
      const params = new URLSearchParams();
      params.append('page', page);

      for (const [key, filter] of Object.entries(this.filters)) {
        if (filter.value !== null && filter.value !== '') {
          params.append(`filters[${key}]`, filter.value);
        }
      }

      return params;
    },
    async fetchSuppliers(event = {}) {
      try {
        this.loading = true;

        const page = event.page ? event.page + 1 : 1;
        const params = this.buildQueryParams(page);
        params.append('per_page', event.rows || this.perPage);

        const response = await SupplierService.index(params);

        if (response) {
          this.suppliers = response.data;
          this.totalRecords = response.meta.total;
          this.currentPage = response.meta.current_page;
        }
      } catch (error) {
        this.$toast.add({
          severity: 'error',
          summary: 'Erro',
          detail: 'Erro ao carregar fornecedores',
          life: 3000,
        });
      } finally {
        this.loading = false;
      }
    },
    emptyFormData() {
      return (this.formData = {
        id: null,
        name: "",
        name2: "",
        fiscalNumber: "",
        telephone: "",
        mobilPhone: "",
        email: "",
        address: "",
        city: "",
        zipCode: "",
        nib: "",
        type: "",
        url: "",
        obs: "",
      });
    },
    closeForm() {
      this.modalVisible = false;
      return this.emptyFormData();
    },
    createSupplier() {
      this.emptyFormData();
      return (this.modalVisible = true);
    },
    createdSupplier() {
      this.fetchSuppliers();
      return this.closeForm();
    },
    updateSupplier(supplier) {
      this.formData = { ...supplier };
      return (this.modalVisible = true);
    },
    updatedSupplier() {
      this.fetchSuppliers({ page: this.currentPage - 1, rows: this.perPage });
      return this.closeForm();
    },
  },
};
</script>
